
import { Component, Vue } from 'vue-property-decorator';
import Search from "@/components/Search.vue";
import Results from "@/components/Results.vue"; // @ is an alias to /src

@Component({
  components: {
    Results,
    Search,
  },
})
export default class Home extends Vue {}
